import React, { Component } from 'react';
import { Button } from './ui/Button';
import { Shield, Lock, CreditCard, Check, Sparkles } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function PricingSection() {
  const tableRows = [{
    name: 'Protocolo Core: Vientre Plano 40+ (28 Días)',
    price: '$97.00'
  }, {
    name: 'Acelerador: Ritual de Infusiones Fisiológicas',
    price: '$29.97'
  }, {
    name: 'Acelerador: Reparación Dulce Anti-Cortisol',
    price: '$39.97'
  }, {
    name: 'Acelerador: Elixires de Mañana',
    price: '$39.97'
  }];
  const benefits = ['El mapa exacto para resetear tu metabolismo en 28 días.', 'El secreto para bloquear la enzima COX-2 (causante de la hinchazón).', 'La libertad de comer chocolate y postres sin inflamar tu cuerpo.', 'Acceso inmediato y de por vida a todas las actualizaciones.'];
  return <section id="resumen-inversion" className="py-5 bg-transparent relative overflow-hidden" data-id="element-500">
      {/* Decorative background */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-501">
        <div className="absolute -top-40 -right-40 w-96 h-96 bg-gold/10 rounded-full blur-3xl" data-id="element-502"></div>
        <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-sage/5 rounded-full blur-3xl" data-id="element-503"></div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-504">
        <div className="max-w-4xl mx-auto" data-id="element-505">
          {/* Header */}
          <div className="text-center mb-8" data-id="element-506">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-black mb-2" data-id="element-507">
              Tu inversión en salud hoy: menos que un café con medialunas.
            </h2>
            <p className="text-lg text-gold font-semibold" data-id="element-508">
              🌸 Especial Mes de la Mujer
            </p>
          </div>

          {/* Value Table */}
          <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-gold/20 mb-8" data-id="element-509">
            <table className="w-full" data-id="element-510">
              <thead data-id="element-511">
                <tr className="bg-sage text-cream" data-id="element-512">
                  <th className="text-left py-3 px-3 sm:px-5 font-serif font-bold text-sm sm:text-base" data-id="element-513">
                    Componente
                  </th>
                  <th className="text-right py-3 px-3 sm:px-5 font-serif font-bold text-sm sm:text-base whitespace-nowrap" data-id="element-514">
                    Valor
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-515">
                {tableRows.map((row, idx) => <tr key={idx} className="border-b border-sage/10 last:border-0" data-id="element-516">
                    <td className="py-3 px-3 sm:px-5 text-sage font-medium text-sm sm:text-base" data-id="element-517">
                      {row.name}
                    </td>
                    <td className="py-3 px-3 sm:px-5 text-right text-sage/70 font-semibold text-sm sm:text-base whitespace-nowrap" data-id="element-518">
                      {row.price}
                    </td>
                  </tr>)}
              </tbody>
              <tfoot data-id="element-519">
                <tr className="border-t-2 border-sage/20 bg-cream/50" data-id="element-520">
                  <td className="py-3 px-3 sm:px-5 font-bold text-sage text-sm sm:text-base" data-id="element-521">
                    Valor Total:
                  </td>
                  <td className="py-3 px-3 sm:px-5 text-right font-bold text-sage line-through text-base sm:text-lg whitespace-nowrap" data-id="element-522">
                    $206.91
                  </td>
                </tr>
                <tr className="bg-gold/10" data-id="element-523">
                  <td className="py-3 px-3 sm:px-5 font-serif font-bold text-sage text-base sm:text-lg" data-id="element-524">
                    Precio Especial:
                  </td>
                  <td className="py-3 px-3 sm:px-5 text-right whitespace-nowrap" data-id="element-525">
                    <span className="text-2xl sm:text-4xl font-serif font-bold text-gold" data-id="element-526">
                      $7.49
                    </span>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </section>;
}